// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__GrAKM","label":"LabeledBox_label__2aInt"};